import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, MenuItem, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';

import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ILookupCategory } from 'src/app/shared/models/lookup.model';
import { SharedService } from 'src/app/shared/services';
import { ISearchPageThemeUserAssignmentUpdate } from '../../models';
import { SearchThemeColumnsAssignService, SearchThemeUsersAssignService } from '../../services';
import { LookupCategory, SearchPageNames } from 'src/app/shared/enums/EnumsVMS';
import { IGlobalSearchParam } from 'src/app/shared/models/Global-Search.model';
import { DatePipe } from '@angular/common';
import * as fs from 'file-saver';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search-themeusers-assign',
  templateUrl: './search-themeusers-assign.component.html',
  styleUrls: ['./search-themeusers-assign.component.css'],
  providers: [DialogService, ConfirmationService, MessageService]
})
export class SearchThemeusersAssignComponent implements OnInit {
  loggedInUserProfile;
  isSearchLoading: boolean = false;
  dialogPosition = 'topright';
  isUserAdd: boolean = false;
  clientCompanyList: any;
  showFilters: boolean;
  showSorting: boolean;
  showToggle: boolean;
  searchPageNamesList: ILookupCategory;
  searchPageNameLkId: any;
  searchPageThemesList: any;
  searchThemeId: any;
  //pageSelected: boolean = false;
  //themeSelected: boolean = false;
  usersList;
  public userIds: Array<any> = [];
  filters;
  appliedFilters: { field: string, matchMode: string, value: string }[] = [];
  userIdValid: boolean = true;
  userSelectIds:any;
  userEditSelectIds;
  themeUsersAssignId;
  oldSortField: string = 'createdOn';
  oldSortOrder: string = 'desc';
  sortField: string = 'createdOn';
  sortOrder: string = 'desc';
  pageNo: number = 1;
  pageSize: number = 10;
  oldPageNo: number = 1;
  oldPageSize: number = 10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  showAddRuleButtonCO: boolean = false;
  showAddRuleButtonMO: boolean = false;
  searchPageThemeUsersSearchParam: IGlobalSearchParam;
  isshowpaginator: boolean = true;
  searchPageThemeUsersSearchSpinner = 'searchPageThemeUsersSearchSpinner';
  searchPageThemeUsersList;
  themeAlreadyExist: boolean = true;
  loading: boolean = false;
  gridSpinner = 'gridSpinner1';
  startSearch: boolean = false;
  selectedGridMenuItem: any = null;
  items: MenuItem[];
  selectedItems;
  isThemeddDisabled: boolean = false;
  isPageddDisabled: boolean = false;
  isPageSelected: boolean = true;
  isThemeSelected: boolean = true;
  isUserSelected: boolean = true;
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  buttonLabel:any;
  allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'searchPageName', header: 'Search Page Name' },
    { value: 'themeName', header: 'Theme Name' },
    { value: 'description', header: 'User Name' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'modifiedBy', header: 'Modified By' },
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'searchPageName', header: 'Search Page Name' },
    { value: 'themeName', header: 'Theme Name' },
    { value: 'description', header: 'User Name' },
    { value: 'createdBy', header: 'Created By' },
    { value: 'modifiedBy', header: 'Modified By' },
  ]
  filterCondition: { fieldName: string; type: string; }[];
  @ViewChild('dt2', { static: true }) table: any;
  @ViewChild('multiSelect') multiSelect: any;

  constructor(
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private searchThemeColumnsAssignService: SearchThemeColumnsAssignService,
    private searchThemeUsersAssignService: SearchThemeUsersAssignService,
    public sharedService: SharedService,
    private messageService: MessageService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.checkViewPermission();
    //this.items = [];
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";
    
    this.matchModeOptions = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
      { label: "Contains", value: FilterMatchMode.CONTAINS }
    ];

    this.matchModeOptionsForDate = [
     { label: "Equals", value: customFilterName },
     { label: "Not Equals", value: notEquals },
     { label: "Greater Than", value: dateAfter },
     { label: "Less Than", value: dateBefore },
    ];

    this.matchModeOptionsForNumeric = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
      { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
    ];

    this.filterCondition = [
      { fieldName: "searchPageName", type: "basic" },
      { fieldName: "themeName", type: "basic" },
      { fieldName: "createdBy", type: "basic" },
      { fieldName: "modifiedBy", type: "basic" },
    ];
    //this.getSearchPageNames();
    //this.getThemeNames();
    //this.getUsersList();
    this.getThemeUsersList();
    // var editItem = {
    //   label:'Edit',
    //  icon:'pi pi-fw pi-pencil',
    //  command: e => this.editSearchThemeUserAssign(this.selectedGridMenuItem.userAssignId),
    // }
    // this.items.push(editItem);
  }
  displayActionMenu() {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    if (isAdminAdd) {
    this.items = [
      {
        label: 'Edit',
        icon: 'pi pi-fw pi-pencil',
        command: e => this.editSearchThemeUserAssign(this.selectedGridMenuItem.userAssignId, this.selectedGridMenuItem.themeId)
      }
    ];
  }
  }
  checkViewPermission()
   {
     var result = this.sharedService.checkPermission("Admin_View");
     if(!result)
     this.router.navigateByUrl('/login');
   }
  addUserAssignDetails() {
    this.buttonLabel= "Add";
    this.isUserAdd = true;
    this.isPageSelected = true;
    this.isThemeSelected = true;
    this.isUserSelected = true;
    this.isThemeddDisabled = false;
    this.isPageddDisabled = false;
    this.selectedItems = "You may select multiple users";
    this.searchPageNameLkId = undefined;
    this.getSearchPageNames();
    this.searchThemeId = undefined;
    this.getThemeNames();
    this.userIds = [];
    this.getUsersList();
  }
  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    // this.applyFilter();
    this.getThemeUsersList()

  }
  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }
  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }
  isShowColumns(columnName) {
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if (tempColumn.length == 1) {
      return true;
    }
    return false;
  }
  getSearchPageNames() {
    //this.categoryName = 'Search Page Names';
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.SearchPageNames).subscribe((data: any) => {
      this.searchPageNamesList = data;
      console.log(data);

    });
  }

  getSearchPageNameOnChange(event) {
    this.searchPageNameLkId = event.value;
    this.isPageSelected = false;
    this.isThemeSelected = true;
    this.isUserSelected = true;
    this.userIds=[];
    this.getThemeNames();
  }

  getThemeNames() {
    this.searchThemeColumnsAssignService.getThemeNames(this.searchPageNameLkId).subscribe((data: any) => {
      this.searchPageThemesList = data;
    });
  }

  getSearchThemeNameOnChange(event) {
    this.searchThemeId = event.value;
    this.isThemeSelected = false;
    this.checkUserAssignmentForTheme(this.searchThemeId);
  }
  checkUserAssignmentForTheme(themeId: number) {
    this.searchThemeUsersAssignService.getCheckUserAssignmentForTheme(themeId).subscribe((data: any) => {
      this.themeAlreadyExist = data;
      if (data == true) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Already users assigned to this theme' });
        console.log('themeAlreadyExist', data);
      }

    });
  }
  editSearchThemeUserAssign(userAssignId: number, themeId: number) {
    this.userIds = [];
    this.selectedItems='You may select multiple users';
    this.getUsersList();
    this.buttonLabel = "Update";
    this.isUserAdd = true;
    this.themeAlreadyExist = false;

    this.searchThemeUsersAssignService.getUserAssign(userAssignId, themeId).subscribe((data: any) => {
      this.isThemeddDisabled = true;
      this.isPageddDisabled = true;
      this.isPageSelected = false;
      this.isThemeSelected = false;
      this.isUserSelected = false;
      this.getSearchPageNames();
      this.searchPageNameLkId = data.searchPageNameLkId;
      this.getThemeNames();
      this.searchThemeId = data.themeId;
      this.getUsersList();
      console.log(data.userProfileIds);
      setTimeout(() => {
        this.searchThemeUsersAssignService.GetSelectedUsers(data.userProfileIds).subscribe((result: any) => {
          console.log(result);
          //this.selectedItems = "You may select multiple certifications";
          if (result.length == 0) {
            this.isUserSelected = true;
          }
          else {
            this.userEditSelectIds=undefined;
            this.isUserSelected = false;
            for (var i = 0; i < result.length; i++) {
              for (var j = 0; j < this.usersList.length; j++) {
                if (result[i].userName == this.usersList[j].userName) {
                  this.userIds.push(this.usersList[j]);
                  this.selectedItems = this.selectedItems + this.usersList[j].firstName;
                  if (this.userEditSelectIds == undefined) {
                    this.userEditSelectIds = this.usersList[j].userProfileId;
                  }
                  else {
                    this.userEditSelectIds = this.userEditSelectIds + ',' + this.usersList[j].userProfileId;
                  }
                }
              }
            }
          }

        });
      }, 500);
    });
  }
  getUsersList() {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
    console.log(this.loggedInUserProfile);
    this.searchThemeUsersAssignService.getUsersList(this.loggedInUserProfile.uid).subscribe((data: any) => {
      this.usersList = data;
      console.log(data);
    });
  }

  getUserListsOnChange(event) {
    if (this.userIds.length == 0) {
      this.selectedItems = 'You may select multiple users.';
      this.isUserSelected = true;
      this.userSelectIds = "";
      this.userEditSelectIds = '';
    }
    else {
      this.isUserSelected = false;
    }
    if (this.themeUsersAssignId != undefined) {
      if (this.userEditSelectIds != '' || this.userEditSelectIds != undefined) {
        this.userEditSelectIds = '';
        for (var m = 0; m < event.value.length; m++) {
          this.userEditSelectIds = this.userEditSelectIds + ',' + event.value[m].userProfileId + ',';
        }

      }
      else {
        if (event.value.length == 1) {
          this.userEditSelectIds = event.value[0].userProfileId;
        }
        else {

          this.userEditSelectIds = "";
          for (var k = 0; k < event.value.length; k++) {
            this.userEditSelectIds = this.userEditSelectIds + ',' + event.value[k].userProfileId + ',';
          }
        }

      }
    }
    else {
      if (event.value.length == 1) {
        this.userSelectIds = event.value[0].userProfileId;
      }
      else {
        this.userSelectIds = "";
        for (var k = 0; k < event.value.length; k++) {
          this.userSelectIds = this.userSelectIds + ',' + event.value[k].userProfileId + ',';
        }
      }
    }
    console.log(this.userSelectIds);
  }

  updateThemeUsersAssignList() {
    var filteredUserSelectId = "";
    var str=this.userSelectIds.toString();
    if (str.includes(",")) {
      var arr = this.userSelectIds.split(',');
      console.log(arr);
      for (var k = 0; k < arr.length; k++) {
        if (arr[k] == "") {

        }
        else {
          if (filteredUserSelectId == "") {
            filteredUserSelectId = arr[k];
          }
          else {
            filteredUserSelectId = filteredUserSelectId + ',' + arr[k];
          }

        }
      }
    }
    else{
      filteredUserSelectId = this.userSelectIds;
    }
    const searchPageThemeUserAssignment: ISearchPageThemeUserAssignmentUpdate = {
      searchPageNameLkId: this.searchPageNameLkId,
      themeId: this.searchThemeId,
      userProfileIds: filteredUserSelectId,
      description: null,
      createdBy: this.loggedInUserProfile.uid,
      modifiedBy: this.loggedInUserProfile.uid,
    }
    this.searchThemeUsersAssignService.updateSearchPageThemeUserAssignment(searchPageThemeUserAssignment).subscribe((data: any) => {
      if(this.buttonLabel =="Add")
      {
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'User(s) assigned successfully' });
      }
      else{
        this.messageService.add({ severity: 'success', summary: 'Confirmed', detail: 'User(s) updated successfully' });
      }
     
      // this.EditIOSInvoiceNumberDialog = false;
      // this.notes = undefined;
      //this.applyFilter();
      this.appliedFilters=[];
      this.isPageSelected = true;
      this.isThemeSelected = true;
      this.isUserSelected = true;
      this.isThemeddDisabled = false;
      this.isPageddDisabled = false;
      this.selectedItems = "You may select multiple users";
      this.searchPageNameLkId = undefined;
      this.getSearchPageNames();
      this.searchThemeId = undefined;
      this.getThemeNames();
      this.userIds = [];
      this.getUsersList();
      this.getThemeUsersList();
    })

  }
  loadThemeUsersList(event: LazyLoadEvent) {
    this.appliedFilters = [];
    this.loadEvent = event;
    if (event.first == 0) {
      this.pageNo = 1;
    }
    else {
      this.pageNo = (event.first / event.rows) + 1;
    }
    this.pageSize = event.rows;

    this.pageSize = event.rows;

    if ((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize)) {
      this.applyFilter();
      //this.getThemeUsersList();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters = event.filters;
    
    this.sortField = event.sortField;
    if (event.sortField === undefined || event.sortField === null) {
      this.sortField = 'createdOn';
    }
    if (event.sortOrder === 1) {
      this.sortOrder = 'desc';
    }
    if (event.sortOrder === -1) {
      this.sortOrder = 'asc';
    }
    if (this.oldSortField !== this.sortField || this.oldSortOrder !== this.sortOrder) {
      this.applyFilter();
      //this.getThemeUsersList()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
    //this.applyFilter();
    // this.getThemeUsersList()
  }


  applyFilter() {
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
            this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: "true"
            })
          }
          else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
            this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: "false"
            })
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
            this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: this.filters[this.filterCondition[i].fieldName][0].value
            })
        }
        else if (this.filterCondition[i].type == "date") {
          for (let j = 0; j <= this.filters[this.filterCondition[i].fieldName].length - 1; j++) {
            if (this.filters[this.filterCondition[i].fieldName][j].value !== null)
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][j].matchMode,
                value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value, "MM-dd-yyyy")
              })
          }
        }
        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
            this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: this.filters[this.filterCondition[i].fieldName][0].value
            })
        }

        else if (this.filterCondition[i].type == "dropdown") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              if (this.filterCondition[i].fieldName != "All") {
                this.appliedFilters.push({
                  field: this.filterCondition[i].fieldName,
                  matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                  value: this.filters[this.filterCondition[i].fieldName][0].value.lookupId
                })
              }
            }
          }
        }

      }
    }
    this.getThemeUsersList();

  }

  applyFilterNew(table: Table) {
    this.filters = table.filters;
    this.applyFilter();
  }
  search() {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.filterCondition[i].type == "checkbox") {
        if (this.filters[this.filterCondition[i].fieldName].value == true) {
          this.appliedFilters.push({ field: this.filterCondition[i].fieldName, matchMode: this.filters[this.filterCondition[i].fieldName].matchMode, value: "true" })
        }
        else if (this.filters[this.filterCondition[i].fieldName].value == false) {
          this.appliedFilters.push({ field: this.filterCondition[i].fieldName, matchMode: this.filters[this.filterCondition[i].fieldName].matchMode, value: "false" })
        }
      }
      else {
        this.appliedFilters.push({ field: this.filterCondition[i].fieldName, matchMode: this.filters[this.filterCondition[i].fieldName].matchMode, value: this.filters[this.filterCondition[i].fieldName].value })
      }
      if (i == this.filterCondition.length - 1) {
        this.startSearch = true;
      }
    }
    if (this.startSearch == true) {
      this.searchPageThemeUsersSearchParam =
      {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        sortField: this.sortField,
        appliedFilters: this.appliedFilters,
        sortOrder: this.sortOrder
      };
      this.spinner.show(this.searchPageThemeUsersSearchSpinner);
      this.searchThemeUsersAssignService.getAllSearchPageThemeUsers(this.searchPageThemeUsersSearchParam).subscribe((data: any) => {
        this.appliedFilters = [];
        this.searchPageThemeUsersList = data;
        this.isshowpaginator = this.searchPageThemeUsersList.length > 0 ? true : false;
        this.totalRecords = data[0].totalCount;
        this.spinner.hide(this.searchPageThemeUsersSearchSpinner);
      });
    }
  }

  getThemeUsersList() {
    this.searchPageThemeUsersSearchParam =
    {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      sortField: this.sortField,
      appliedFilters: this.appliedFilters,
      sortOrder: this.sortOrder
    };
    this.spinner.show(this.searchPageThemeUsersSearchSpinner);
    this.searchThemeUsersAssignService.getAllSearchPageThemeUsers(this.searchPageThemeUsersSearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      // const distinctdata = data.filter(
      //   (data, i, arr) => arr.findIndex(t => t.themeId === data.themeId) === i
      // );
      //console.log('data', distinctdata);
      this.searchPageThemeUsersList = data;
      console.log(data);
      this.isshowpaginator = this.searchPageThemeUsersList.length > 0 ? true : false;
      this.totalRecords = data[0].totalCount;
      //this.totalRecords = datadistinctdata[0].totalCount;
      //this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.searchPageThemeUsersSearchSpinner);
    });
  }

  cancelThemeUsersAssign() {
    this.isPageSelected = true;
    this.isThemeSelected = true;
    this.isUserSelected = true;
    this.isThemeddDisabled = false;
    this.isPageddDisabled = false;
    this.selectedItems = "You may select multiple users";
    this.searchPageNameLkId = undefined;
    this.getSearchPageNames();
    this.searchThemeId = undefined;
    //this.getThemeNames();
    this.userIds = [];
    this.getUsersList();
    this.isUserAdd = false;
    this.multiSelect.filterValue = '';

  }
  exportSearchPageThemeUsersAssign() {
    this.applyFilter();
    this.searchPageThemeUsersSearchParam =
    {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      sortField: this.sortField,
      appliedFilters: this.appliedFilters,
      sortOrder: this.sortOrder
    };
    this.searchThemeUsersAssignService.ExportSearchPageThemeUsersAssign(this.searchPageThemeUsersSearchParam).subscribe(res => {
      var blob = new Blob([res.body], { type: res.body.type });
      const file = new File([blob], "SearchPageTheme.xlsx", { type: res.body.type });
      fs.saveAs(file);
    });
  }

}
